import { render, staticRenderFns } from "./FuncionarioIndex.vue?vue&type=template&id=546ba000"
import script from "./FuncionarioIndex.vue?vue&type=script&lang=js"
export * from "./FuncionarioIndex.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports